import Base from './Base';

class Attributions extends Base {}

export default Attributions;
